import {
  ContractActions,
  LOAD_PRODUCT_CONTRACT_COMPLETE,
  LOAD_CONTRACT_BALANCE_COMPLETE,
  LOAD_CONTRACT_PAYMENTS_COMPLETE,
  RESET,
} from '../../actions/contract.actions';
import { ISalesDocument } from '@cemex-core/cmx-api/models/product/models/sales-document.interface';
import { ContractBalance } from '../../models/contract-balance';
import { PaymentTerm } from '@cemex-core/cmx-api';

/**
 * Observation:
 * The way contracts are being stored could cause an overflow
 * if the user never refreshes or changes the product selected too many times.
 *
 * ([productId]: [...]) could be sotred to infinity even when some products are not selected anymore.
 * Also, when coming back to a product that was selected before, even when already having its available contracts,
 * it will make the call again to fetch its available contracts.
 * So maybe we should start at least cleaning the object by deleting any [productId] from there when it gets unselected.
 */
export interface ContractState {
  availableContracts: {
    [productId: string]: ISalesDocument[];
  };
  contractsBalance: {
    [salesDocumentItemId: number]: ContractBalance;
  };
  contractsPayments: {
    [productId: string]: {
      [salesDocumentItemId: number]: PaymentTerm[];
    };
  };
}

export const initialState: ContractState = {
  availableContracts: {},
  contractsBalance: {},
  contractsPayments: {},
};

export function contractReducer(state = initialState, action: ContractActions): ContractState {
  switch (action.type) {
    case LOAD_PRODUCT_CONTRACT_COMPLETE: {
      return {
        ...state,
        availableContracts: {
          ...state.availableContracts,
          [action.payload.productId]: action.payload.salesDocuments,
        },
      };
    }
    case LOAD_CONTRACT_BALANCE_COMPLETE: {
      return {
        ...state,
        contractsBalance: {
          ...state.contractsBalance,
          ...action.payload,
        },
      };
    }
    case LOAD_CONTRACT_PAYMENTS_COMPLETE: {
      return {
        ...state,
        contractsPayments: {
          ...state.contractsPayments,
          [action.payload.productId]: {
            ...state.contractsPayments[action.payload.productId],
            [action.payload.salesDocumentId]: action.payload.paymentTerms,
          },
        },
      };
    }
    case RESET: {
      return { ...initialState };
    }
    default: {
      return state;
    }
  }
}
